<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66.193"
    height="86.127"
    xmlns:v="https://vecta.io/nano"
  >
    <defs>
      <clipPath id="A">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-452.468 -446.542)" />
      </clipPath>
      <clipPath id="B">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-461.497 -420.945)" />
      </clipPath>
      <clipPath id="C">
        <path d="M0 841.89h595.276V0H0z" transform="translate(-421.55 -432.26)" />
      </clipPath>
    </defs>
    <g
      transform="translate(-550.47 -518.426)"
      fill="none"
      stroke="#fff"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    >
      <path d="M579.178 603.22h-21.036l-6.339-41.236h30.059z" stroke-width="2.667" />
      <g stroke-width="2">
        <path
          d="M0 0a5.53 5.53 0 0 0-5.528-5.528A5.53 5.53 0 0 0-11.056 0a5.53 5.53 0 0 0 5.528 5.528A5.53 5.53 0 0 0 0 0z"
          transform="matrix(1.333333 0 0 -1.333333 603.2912 527.1304)"
          clip-path="url(#A)"
        />
        <path
          d="M0 0l-4.422-31.47-6.081 19.932-11.424-19.932 4.681 32.922-3.207 10.595-20.453 6.265 32.062 1.474C-1.513 20.268 0 0 0 0z"
          transform="matrix(1.333333 0 0 -1.333333 615.32933 561.26013)"
          clip-path="url(#B)"
        />
        <path
          d="M0 0s-.906-5.358-5.433-6.791c0 0 .83-2.938 5.056-2.299s7.093 1.022 8.3 0c0 0-.865 4.6 5.131 7.279 0 0-9.507-1.283-13.054 1.811z"
          transform="matrix(1.333333 0 0 -1.333333 562.06627 546.17333)"
          clip-path="url(#C)"
        />
      </g>
    </g>
  </svg>
</template>
